import React from 'react';
import BoxedContainer from '../components/layouts/BoxedContainer';

export default function HtmlContent({ data }) {
  return (
    <section
      className="bg-b-1 lg:pt-[120px] pt-[80px] lg:pb-[180px] pb-[90px] lg:-mt-[80px]
    -mt-[20px]"
    >
      <BoxedContainer className="regular">
        <div
          dangerouslySetInnerHTML={{ __html: data.htmlContent }}
          className="font-roboto-regular flex flex-col lg:gap-y-5 gap-y-3 lg:text-base
          text-[15px] leading-7 html-content:text-xl li-child:list-disc ul-child:pl-5
          html-content"
        />
      </BoxedContainer>
    </section>
  );
}
